module.exports = __webpack_public_path__ + "static/img/result_desk.ed674b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_desk.jpg
// module id = 6yCz
// module chunks = 3